import TripsPlanningScreen from './TripsPlanningScreen';

export default TripsPlanningScreen;
